<template>
  <div class="container">
    <van-sticky>
      <div v-if="!isRiskComplaint" class="h-wrap">
        <div class="h-box" :data-active="state.sourceType">
          <div
            v-for="(it, i) in ['自营', '团队']"
            :class="{ ae: state.sourceType === i + 1 }"
            class="h-it"
            @click="onType(i + 1)"
          >
            {{ it }}
          </div>
        </div>
      </div>
      <van-tabs
        v-if="enableLeagueJt"
        v-model:active="state.includeLeagueOrder"
        :line-width="13"
        animated
        @clickTab="getInfo"
      >
        <van-tab v-for="(it, i) in ['商城自营', '推客自营']" :name="i + 1" :title="it" />
      </van-tabs>
    </van-sticky>
    <div class="list-wrap">
      <div class="list-item-box" v-for="(item, index) in list">
        <div class="list-header">
          <div class="flex">
            <div class="line"></div>
            <div>{{ item.titles[0] }}数据</div>
          </div>
          <SvgIcon
            v-if="!index && !isRiskComplaint"
            name="icon-asignal"
            size="20"
            color="#999"
            @click="showDialog({ confirmButtonText: '知道了', ...msg[state.sourceType] })"
          />
        </div>
        <div class="list-grid">
          <div class="grid-item" v-for="(col, idx) in item.items">
            <div class="text-13px">{{ col.item[0].text.replace(item.titles[0], '') }}</div>
            <CountTo class="count" :endVal="col.item[0].value" :decimals="col.item[0].text.includes('元') ? 2 : 0" />
            <div
              :class="{
                'text-[#5CC480]': col.item[0].value < col.item[1].value,
                'text-[#FB3729]': col.item[0].value >= col.item[1].value
              }"
              class="text-12px mt-8px flex items-center"
            >
              <div>{{ item.titles[1] }}</div>
              <div class="text-13px ml-2px">{{ col.item[1].value }}</div>
              <img
                class="w-12px ml-2px"
                :src="
                  col.item[0].value < col.item[1].value
                    ? 'https://i.xurl.cn/x_dsx_h5/icons/icon_green.png'
                    : 'https://i.xurl.cn/x_dsx_h5/icons/icon_red.png'
                "
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { CountTo } from 'vue3-count-to'
import { onMounted, ref, reactive } from 'vue'
import { useUserStore } from '@/store/user'
import { getStatisticsDate } from '@/api/data'
import SvgIcon from '@/components/SvgIcon.vue'
import { showDialog, showLoadingToast, closeToast } from 'vant'

const { isRiskComplaint } = useUserStore()
const state = reactive({ sourceType: 1, includeLeagueOrder: 1 })
const enableLeagueJt = ref(false)
const list = ref([])
const dates = [
  ['今日', '昨日'],
  ['本周', '上周'],
  ['本月', '上月'],
  ['今年', '去年']
]
const msg = {
  1: {
    title: '“自营”的数据指标说明',
    message:
      '代理/准代理自己店铺出单时，销售额按销售价（注册用户的价格）计算，进货额按代理/准代理对应级别的代理价计算，销售额减去进货额等于利润。'
  },
  2: {
    title: '“团队”的数据指标说明',
    message:
      '基于相同的时间维度及上述指标说明，销售额为团队成员的销售额之和，进货额为团队成员的进货额之和，利润为团队成员的利润之和，销量为团队成员销量之和，销售单数为团队成员销售单数之和。'
  }
}

function onType(v) {
  state.sourceType = v
  getInfo()
}

const getInfo = async () => {
  try {
    showLoadingToast({ message: '加载中...', duration: 0, forbidClick: true })
    const res = await getStatisticsDate(state)
    enableLeagueJt.value = res.enableLeagueJt
    list.value = res.columns.map((it, i) => ({ ...it, titles: dates[i] }))
  } finally {
    closeToast()
  }
}

onMounted(getInfo)
</script>

<style lang="less" scoped>
.h-wrap {
  display: flex;
  justify-content: center;
  padding: 6px 0;
  background: #ffffff;
  .h-box {
    background: #f6f6f6;
    border-radius: 8px;
    padding: 2px;
    display: flex;
    position: relative;
    .h-it {
      width: 80px;
      height: 28px;
      border-radius: 6px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #666666;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      position: relative;
      z-index: 1;
    }
    .ae {
      background: #ffffff;
      color: #222222;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }

    &::before {
      content: '';
      position: absolute;
      top: 2px;
      left: 2px;
      width: 80px;
      height: 28px;
      background: #ffffff;
      border-radius: 6px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      z-index: 0;
    }

    &[data-active='1']::before {
      transform: translateX(0);
    }

    &[data-active='2']::before {
      transform: translateX(80px);
    }
  }
}
.list-wrap {
  padding: 10px;
  .list-item-box {
    padding: 8px 12px;
    background: #ffffff;
    border-radius: 8px;
    font-size: 13px;
    color: #000000;
    .list-header {
      padding: 8px 0;
      display: flex;
      justify-content: space-between;
      font-weight: 500;
      font-size: 16px;
      .line {
        width: 3px;
        height: 12px;
        background: #fd7f5c;
        margin-right: 11px;
      }
    }
    .list-grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      grid-gap: 8px;
      padding: 8px 0;
      .grid-item {
        background: #fafafa;
        border-radius: 8px;
        padding: 10px;
        .count {
          font-size: 20px;
          font-weight: 600;
          margin-top: 8px;
          display: block;
        }
      }
    }
  }
  .list-item-box:not(:last-child) {
    margin-bottom: 10px;
  }
}
</style>
